<template>
  <div class="mymoney">
    <GlobTopNav :title="title" :rightHidden="false"> </GlobTopNav>
    <div class="headerbox">
      <!-- <top-nav ref="TopNav"></top-nav>
      <van-nav-bar :title="title" @click-right="onClickRight">
        <van-icon slot="left" class="iconfont icon-zuojiantou" style="font-size: .25rem" @click="goBack"></van-icon>
        <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
      </van-nav-bar> -->

      <div class="mymoneyhead">
        <div class="mymoneyheadjifen">
          <span v-html="n_points != null ? n_points : '0'"></span>
          <span class="my-jf">我的{{ unit }}</span>
        </div>
        <div class="mymoneyhead-all">
          <div class="all-item">
            <span class="points">{{ t_points }}</span>
            <span class="plj">{{ unit }}累计</span>
          </div>
          <div class="all-item">
            <span class="points">{{ u_points }}</span>
            <span class="plj">{{ unit }}消耗</span>
          </div>
        </div>

        <router-link class="examples-of"  v-if="this.$store.state.webCount.send_status == 1" to="/user/presented"> {{unit}}转赠 </router-link>
      </div>
    </div>

    <div class="integral-record">
      <van-tabs v-model="active" @click="vantabPlay">
        <van-tab
          v-for="index in 3"
          :title="index == 1 ? '全部' : index == 2 ? '收入' : index == 3 ? '支出' : ''"
          :key="index"
        >
          <div class="van-content">
            <div class="nodata text-cent" v-if="finished && datas == ''">
              <p class="imgbox">
                <img src="/static/images/nodataimg.png" />
              </p>
              <p class="text">暂无记录~</p>
            </div>

            <van-list v-model="loading" :finished="finished">
              <div class="cont-list">
                <!--<router-link v-for="(items,index) in datas" :to="{path:'/user/mymoney/money',query:{id:items.id}}" tag="div" :key="items.id">-->
                <div v-for="(items, index) in datas" :key="items.id" class="van-cell van-hairline">
                  <div style="width: 75%">
                    <span class="van-cell-text">{{ items.memo }}</span>
                    <div class="van-cell__label">{{ time(items.time) }}</div>
                  </div>
                  <div class="point" style="width: 25%; text-align: right">
                    <span :class="items.type == 1 ? 'reduction-add' : 'reduction-of'">
                      <span
                        :class="items.type == 1 ? 'reduction-add' : 'reduction-of'"
                        v-html="items.type == 1 ? '+' : '-'"
                      >
                      </span>
                      {{ items.point }}
                    </span>
                  </div>
                </div>
                <!--</router-link>-->
              </div>
              <div v-if="finished == true && datas != ''" class="nomore">
                <div class="theEnd">- 已经到底了 -</div>
              </div>
            </van-list>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import TopNav from "@/components/topnav";
import store from "../../../vuex/store";
export default {
  name: "mymoney",
  components: {
    TopNav
  },
  store,
  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    }
  },
  data() {
    return {
      datas: [],
      page: 0,
      active: 0,
      type: 0,
      finished: false,
      loading: false,
      t_points: 0,
      u_points: 0,
      n_points: 0,
      title: ""
    };
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    time: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    },
    vantabPlay(index) {
      this.datas = [];
      this.type = index;
      //        this.page = 0
      //        if(this.finished){
      //          this.finished = false
      //        }else{
      this.loading = true;
      this.getDatas();
      //        }
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      _this.finished = false;
      //        setTimeout(() => {
      //          this.page++;
      this.$api.get(
        "user/point/list",
        { id_example: mallid, token_user: isUser, status: this.type },
        res => {
          if (res.data.code == "100") {
            if (res.data.data.list.length == 0) {
              _this.finished = true;
              _this.loading = false;
            } else {
              _this.u_points = res.data.data.cost_point;
              _this.n_points = res.data.data.point;
              _this.t_points = res.data.data.tatal_point;
              for (let i = 0; i < res.data.data.list.length; i++) {
                _this.datas.push(res.data.data.list[i]);
              }
              _this.finished = true;
              _this.loading = false;
            }
          } else if (res.data.message == "token验证失败") {
            this.$dialog
              .confirm({
                title: "提示 ",
                message: "登录过期请重新登录"
              })
              .then(() => {
                this.$router.push({ name: "NoteLogin" });
              })
              .catch(() => {});
          } else {
            this.$toast(res.data.message);
          }
        }
      );
      //        },50)
    }
  },
  mounted() {
    this.getDatas();
    setTimeout(() => {
      var unit = localStorage.getItem("unit");
      var unitname = "我的" + unit;
      this.title = unitname;
    }, 200);
  }
};
</script>

<style lang="less">
.mymoney {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background: #f5f5f5;
  padding-bottom: 1rem;

  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 2.92rem;
    background-color: rgba(212, 35, 35, 1);
    background-image: url("./../../../assets/img/jf-bg.png");
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .headerbox {
    position: relative;
    z-index: 2;
    width: calc(100% - 0.6rem);
    height: 3.3rem;
    margin: 0 auto;
    background: #ffffff;
    box-shadow: 0rem 0.3rem 0.2rem -0.12rem rgba(162, 162, 162, 0.15);
    border-radius: 0.24rem;
    background-color: #fff;
    margin-top: 1.26rem;

    .mymoneyhead {
      box-sizing: border-box;
      padding: 0.4rem;
      position: relative;
      .mymoneyheadjifen {
        font-size: 0.6rem;
        font-weight: 400;
        color: #d52c2c;
        line-height: 0.84rem;
        display: flex;
        flex-direction: column;

        .my-jf {
          font-size: 0.24rem;
          font-weight: 400;
          color: #929292;
          line-height: 0.42rem;
        }
      }

      .mymoneyhead-all {
        margin-top: 0.4rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .all-item {
          min-width: 2rem;
          display: flex;
          align-items: flex-start;
          flex-direction: column;

          .points {
            font-size: 0.36rem;
            font-weight: 400;
            color: #262626;
            line-height: 0.5rem;
          }

          .plj {
            font-size: 0.24rem;
            font-weight: 400;
            color: #929292;
            line-height: 0.42rem;
          }
        }
      }

      .examples-of {
        min-width: 1rem;
        height: 0.48rem;
        padding: 0 0.1rem 0 0.2rem;
        background: linear-gradient(204deg, #deb37b 0%, #ffddb6 100%);
        box-shadow: 0rem 0.08rem 0.08rem 0rem rgba(118, 118, 118, 0.15);
        border-radius: 0.24rem 0rem 0rem 0.24rem;
        position: absolute;
        top: 0.58rem;
        right: 0;
        font-size: 0.24rem;
        font-weight: 400;
        color: #895616;
        line-height: 0.48rem;
        text-align: center;
      }
    }
  }
  .integral-record {
    width: calc(100% - 0.6rem);
    height: 100%;
    margin: 0.4rem auto 0 auto;
    border-radius: 0.24rem;
    overflow: hidden;
    padding-bottom: 0.2rem;
    background: #fff;

    .van-content {
      min-height: 50vh;
      padding-bottom: 0;

      .cont-list {
        .van-cell {
          border-bottom: 0.01rem solid #f2f2f2;

          &::after {
            border-bottom: 0rem solid #ebedf0;
          }
          .van-cell-text {
            font-size: 0.28rem;
            font-weight: 400;
            color: rgba(38, 38, 38, 0.8);
            line-height: 0.48rem;
          }

          .van-cell__label {
            font-size: 0.24rem;
            font-weight: 400;
            color: #929292;
            line-height: 0.42rem;
          }

          .reduction-of {
            font-size: 0.28rem;
            font-weight: 400;
            color: #fe5c42;
            line-height: 0.4rem;
          }

          .reduction-add {
            font-size: 0.28rem;
            font-weight: 400;
            line-height: 0.4rem;
            color: rgba(2, 91, 255, 1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/mymoney/mymoney.vue